import type { Language } from '@/shared/entities/Language'

export class CancelPackageReasonEntity {
  id?: number
  translations?: Array<{
    title?: string | null
    language?: Language
  }> | null
}
